import { FirebaseDocRefType } from 'firebase/index'
import { Action, Dispatch } from 'redux'
import { fetchPointCardAction } from 'reducks/pointCard/actions'
import { fetchPointCardByBrandRef } from 'repos/pointCard'

const fetchPointCard = (brandRef: FirebaseDocRefType) => {
  return async (dispatch: Dispatch<Action>) => {
    const pointCard = await fetchPointCardByBrandRef(brandRef)
    if (!pointCard) return
    dispatch(fetchPointCardAction(pointCard))
  }
}

export default fetchPointCard
